import { FC, useEffect } from 'react';

/**
 * Reloads if path is not registered by client.
 * This is required since the new Header uses <RouterLink /> wich do not trigger a page reload.
 */
const ReloadLink: FC = () => {
  useEffect(() => window.location.reload(), []);

  return null;
};

export default ReloadLink;
